import { ColumnDef } from "@tanstack/react-table"

import { ZonePolicyDueDateType } from "@/types/index"

import { DataTableColumnHeader } from "../../data-table"
import { ZonesPolicyOperation } from "../operations/zone-policy-operations"

export const zonePolicyDueColumns: ColumnDef<ZonePolicyDueDateType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => {
      const value = row.original.id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "zone_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone Id" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone_id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "zone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "before_due_reminder",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Before Due Reminder" />
    ),
    cell: ({ row }) => {
      const value = row.original.before_due_reminder
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "overdue_reminder",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Over Due Reminder" />
    ),
    cell: ({ row }) => {
      const value = row.original.overdue_reminder
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "disconnection_reminder",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Disconnection Reminder" />
    ),
    cell: ({ row }) => {
      const value = row.original.disconnection_reminder
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <ZonesPolicyOperation data={row.original} />
        </div>
      )
    },
  },
]
